/* TODO: t() */
import React, { Component, CSSProperties, createRef } from 'react';
import { Prose } from '@nikolovlazar/chakra-ui-prose';

type Props = {
  content: string;
  className?: string;
  style?: CSSProperties;
};

type State = {
  oldContent: string;
  parsedContent: HTMLElement | null | undefined;
};

export default function RawHTMLBlock(props: Props) {
  const { content, ...otherProps } = props;
  return (
    <Prose as="div" {...otherProps}>
      <RawBlock content={content} />
    </Prose>
  );
}

class RawBlock extends Component<Props, State> {
  _ref = createRef<HTMLDivElement>();

  state: State = {
    oldContent: '',
    parsedContent: null,
  };

  static getDerivedStateFromProps(props: Props, state: State) {
    let { content } = props;
    if (content === state.oldContent) {
      return null;
    }
    let parsed = parseHTML(content);
    return {
      oldContent: content,
      parsedContent: parsed,
    };
  }

  componentDidMount() {
    renderContent(this._ref.current, this.state.parsedContent);
  }

  componentDidUpdate() {
    renderContent(this._ref.current, this.state.parsedContent);
  }

  render() {
    return <div ref={this._ref} />;
  }
}

function renderContent(
  container: HTMLDivElement | null | undefined,
  content: HTMLElement | null | undefined,
) {
  if (container) {
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }
    content && container.appendChild(content);
  }
}

function parseHTML(html: string): HTMLElement {
  let parser = new DOMParser();
  let doc = parser.parseFromString(html, 'text/html');
  let body = doc.body || document.createElement('body');
  let node = body.childNodes.length === 1 ? body.firstChild : null;
  if (node instanceof HTMLElement) {
    return node;
  } else {
    let div = document.createElement('div');
    for (let child of Array.from(body.childNodes)) {
      div.appendChild(child);
    }
    return div;
  }
}

export { parseHTML as parseHTMLForTesting };
